
'use strict';

define('component!LoginFormComponent',['require','prop-types','react','component!ButtonComponent','lib/Podio.Colors','classnames'],function (require) {
  'use strict';

  var PropTypes = require('prop-types');

  var React = require('react');
  var Button = require('component!ButtonComponent');
  var PodioColors = require('lib/Podio.Colors');
  var classNames = require('classnames');

  var LoginFormComponent = function LoginFormComponent(props) {
    var emailClasses = classNames('login-form-component__input-fields__row__input', {
      'invalid-field': props.validation.email.invalid
    });

    var passwordClasses = classNames('login-form-component__input-fields__row__input', {
      'invalid-field': props.validation.password.invalid
    });

    return React.createElement(
      'form',
      { className: 'login-form-component', id: 'loginForm', onSubmit: props.onSubmit, onKeyPress: props.onKeyPress },
      React.createElement(
        'h2',
        { className: 'login-form-component__header' },
        props.translations.podio_sign_in
      ),
      React.createElement(
        'div',
        { className: 'login-form-component__input-fields login' },
        React.createElement(
          'div',
          { className: 'login-form-component__input-fields__row__name' },
          props.translations.email
        ),
        React.createElement(
          'div',
          { className: 'login-form-component__input-fields__row' },
          React.createElement('input', {
            className: emailClasses,
            autoFocus: true,
            required: true,
            id: 'email',
            name: 'email',
            tabIndex: '1',
            type: 'email',
            onChange: props.onChange,
            onBlur: props.onBlur,
            value: props.email })
        ),
        React.createElement(
          'div',
          { className: 'login-form-component__input-fields__row__name' },
          props.translations.password
        ),
        React.createElement(
          'div',
          { className: 'login-form-component__input-fields__row' },
          React.createElement('input', {
            className: passwordClasses,
            id: 'password',
            name: 'password',
            tabIndex: '2',
            type: 'password',
            required: true,
            onChange: props.onChange,
            onBlur: props.onBlur,
            value: props.password })
        )
      ),
      React.createElement(Button, {
        type: 'submit',
        id: 'loginFormSignInButton',
        name: 'commit',
        className: 'login-form-component__button',
        tabIndex: '3',
        disabled: props.isSubmitting,
        label: props.translations.sign_in }),
      React.createElement(
        'div',
        { className: 'login-form-component__footer' },
        React.createElement(
          'div',
          { className: 'login-form-component__footer__remember-me' },
          React.createElement('input', {
            id: 'remember_me',
            name: 'remember_me',
            type: 'checkbox',
            defaultChecked: true,
            onChange: props.onChange,
            value: props.rememberMe }),
          React.createElement(
            'label',
            { htmlFor: 'remember_me', tabIndex: '4', className: 'login-form-component__footer__remember-me__label' },
            props.translations.remember_me
          )
        ),
        React.createElement(
          'div',
          { className: 'login-form-component__footer__forgot-password' },
          React.createElement(
            'a',
            { className: 'login-form-component__footer__forgot-password__link', href: '/user/recover/', tabIndex: '5' },
            ' ',
            props.translations.forgot_password
          )
        )
      )
    );
  };

  LoginFormComponent.propTypes = {
    translations: PropTypes.shape({
      podio_sign_in: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      password: PropTypes.string.isRequired,
      sign_in: PropTypes.string.isRequired,
      remember_me: PropTypes.string.isRequired,
      forgot_password: PropTypes.string.isRequired
    }),
    email: PropTypes.string,
    password: PropTypes.string,
    rememberMe: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onKeyPress: PropTypes.func,
    validation: PropTypes.shape({
      email: PropTypes.shape({
        invalid: PropTypes.bool,
        errorMessage: PropTypes.string
      }),
      password: PropTypes.shape({
        invalid: PropTypes.bool,
        errorMessage: PropTypes.string
      })
    }),
    isSubmitting: PropTypes.bool
  };
  return LoginFormComponent;
});
